export default __webpack_public_path__ + "media/images/icons/icon-type-32e79ab08e7a934920e590060c18ef5c.svg";